<template>
  <teleport to="body">
    <div class="fixed bottom-4 right-4 z-[60] flex flex-col gap-2">
      <TransitionGroup name="toast">
        <div
          v-for="t in toasts"
          :key="t.id"
          class="min-w-[260px] max-w-[92vw] rounded-xl border shadow-lg px-4 py-3 backdrop-blur bg-white/90 flex items-start gap-3 border-gray-200"
        >
          <span
            class="mt-1 w-2 h-2 rounded-full shrink-0"
            :class="{
              'bg-green-500': t.type === 'success',
              'bg-red-500': t.type === 'error',
              'bg-blue-500': t.type === 'info',
            }"
          />
          <div class="text-sm text-gray-800">{{ t.message }}</div>
          <button
            class="ml-auto text-gray-500 hover:text-gray-800"
            aria-label="Закрити"
            @click="remove(t.id)"
          >
            ✕
          </button>
        </div>
      </TransitionGroup>
    </div>
  </teleport>
</template>

<script setup>
import { useToast } from "~/composables/useToast";
const { toasts, remove } = useToast();
</script>

<style scoped>
.toast-enter-from,
.toast-leave-to {
  opacity: 0;
  transform: translateY(8px) scale(0.98);
}
.toast-enter-active,
.toast-leave-active {
  transition: all 0.18s ease;
}
</style>
